import { Alert } from 'react-bootstrap';

import type { ModalDependencyData } from './types';

type ModalAddDependencyAlertProps = {
  dependencyToAdd: ModalDependencyData;
};

// Error alert to display in the ModalAddDependency tabs
export const ModalAddDependencyAlert = ({ dependencyToAdd }: ModalAddDependencyAlertProps) =>
  dependencyToAdd.error ?
    <Alert className="modal-add-dependency-alert" bsStyle="error">
      {dependencyToAdd.error}
    </Alert> :
    null;
